import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { CONTAINER_SIZES } from '../../../constants/sizes.js';
import { Icon } from '../../Icon/src/Icon.js';
import modules_28f16a69 from '../styles/Avatar.module.less.js';
import { getSize } from '../utils/getSize.js';
import { getTextSize } from '../utils/getTextSize.js';
import SizeContext from './SizeContext.js';

/**
 * @description The Avatar component is used to represent users. And should only be used for avatars and logotypes
 *
 * @component
 * @example
 * ```jsx
 * <Avatar src="image.png" />
 * ```
 */
const Avatar = React.forwardRef((props, ref) => {
    const groupSize = React.useContext(SizeContext);
    const { size = CONTAINER_SIZES.S44, className, children, ...restProps } = props;
    const cx = useStyles(modules_28f16a69);
    const classNames = cx(className, 'avatar', {
        [`size-${getTextSize(size)}`]: size,
    });
    return (React.createElement(Icon, { "data-qa": "Avatar", ref: ref, size: getSize(groupSize || size), shape: "round", background: "dark", objectFit: "cover", className: classNames, ...restProps }, children));
});
Avatar.displayName = 'Avatar';

export { Avatar };
//# sourceMappingURL=Avatar.js.map
